module.exports = __webpack_public_path__ + "static/img/weixincode.70044b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/weixincode.jpg
// module id = nouU
// module chunks = 51